import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { Pivotv2RoutingModule } from './pivotv2-routing.module';
import { Pivotv2Component } from './pivotv2.component';
import {
  DxChartModule, DxScrollViewModule, DxAutocompleteModule, DxDataGridModule, DxPopupModule, DxButtonModule,
  DxDropDownButtonModule, DxPivotGridModule, DxPivotGridFieldChooserModule, DxCheckBoxModule,
  DxLoadPanelModule, DxTooltipModule
} from 'devextreme-angular';


@NgModule({
  declarations: [Pivotv2Component],
  imports: [
    CommonModule,
    Pivotv2RoutingModule,
    DxChartModule,
    DxScrollViewModule,
    DxAutocompleteModule,
    DxDataGridModule,
    DxPopupModule,
    DxButtonModule,
    DxDropDownButtonModule,
    DxPivotGridModule,
    DxPivotGridFieldChooserModule,
    DxCheckBoxModule,
    DxLoadPanelModule,
    DxTooltipModule,DxScrollViewModule
  ]
})
export class Pivotv2Module { }
